import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';

import Button from '../../common/Button';
import InputPrimary from '../../common/InputPrimary';
import {
  maxCharLength,
  isValidURL,
  areValidURLs,
  required,
  TextArea,
} from '../../utils/form';
import { FieldFileInput } from '../../user/edit/Form';

const max = 280;
const maxCharLengthValidator = maxCharLength(max);

const InputName = (field) => (
  <InputPrimary
    type="text"
    className="u-margin-bottom-tiny"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

const InputMoreInfoUrl = (field) => (
  <InputPrimary
    type="text"
    className="u-margin-bottom-tiny"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

const InputUrls = (field) => (
  <InputPrimary
    type="text"
    className="u-margin-bottom-huge"
    align="left"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

let Form = ({
  handleSubmit,
  onSubmit,
  submitting,
  error,
  okButtonText,
  t,
  invalid,
}) => (
  <form onSubmit={handleSubmit}>
    <Field
      component={InputName}
      name="name"
      label={t('project.create.nameLabel')}
      placeholder={t('project.create.namePlaceholder')}
      validate={[required]}
      required
    />
    <Field
      component={TextArea}
      name="description"
      label={t('project.create.descrLabel')}
      validate={[required, maxCharLengthValidator]}
      max={max}
      maxBy="CHAR"
      required
      placeholder={t('project.create.descrPlaceholder')}
    />
    <Field
      component={FieldFileInput}
      name="logoUrl"
      label={t('project.create.logoLabel')}
      placeholder={t('project.create.logoPlaceholder')}
    />
    <Field
      component={InputMoreInfoUrl}
      name="moreInfoUrl"
      label={t('project.create.urlLabel')}
      placeholder={t('project.create.urlPlaceholder')}
      validate={[isValidURL]}
    />

    {/* TODO: Use the component below to input urls */}
    <Field
      component={InputUrls}
      name="urls"
      label={t('project.create.urlsLabel')}
      placeholder={t('project.create.urlsPlaceholder')}
      validate={[areValidURLs]}
    />
    {/* <h3 className="c-heading--alpha u-margin-top-large">Links to more details</h3>
    <div className="u-display-flex u-align-items-center u-margin-bottom-tiny">
      <span className="c-input-url__icon"></span>
      <textarea type="text" className="c-input c-input-url" placerholder="Add URL" rows="1">https://gitlab.com/dev-labs-bg/chuzdhitsa-website</textarea>
    </div>
    <div className="u-display-flex u-align-items-center u-margin-bottom-tiny">
      <span className="c-input-url__icon"></span>
      <textarea type="text" className="c-input c-input-url" placerholder="Add URL" rows="1">https://trello.com/chuzdhitsa-bg</textarea>
    </div>
    <button className="c-btn c-btn-outline">+ new project
    </button> */}

    <div className="u-margin-top-huge u-text-center">
      <Button
        disbaled={invalid ? 1 : 0 || submitting ? 1 : 0}
        type="submit"
        className={`${invalid ? 'c-btn--disabled' : ''}`}
      >
        {submitting ? t('general.sending') : okButtonText}
      </Button>
    </div>

    {error && <p className="c-alert c-alert--danger u-margin-top">{error}</p>}
  </form>
);

Form = reduxForm({ form: 'project-create' })(translate()(Form));

export default Form;



// WEBPACK FOOTER //
// ./src/projects/create/Form.js